/**
 * Tipos de situação de usuario para portal do cliente
 */
export enum DashboardUserStatus {
  /**
   * Conta ativa
   */
  Enabled = 'ENABLED',
  /**
   * Conta bloqueada
   */
  Blocked = 'BLOCKED',
  /**
   * Conta com algum erro que precisa ser tratado pela tecnologia
   */
  Error = 'ERROR',
  /**
   * Conta pendente
   */
  Pending = 'PENDING',
}

export class DashboardUser {
  uuid!: string;
  email!: string;
  phone_number!: string;
  status!: string;
  business_unit_uuid!: string;
  name!: string;
  document!: string;
  created_at!: string;
  updated_at!: string;
  avatar_url!: string;
}

export const translateDashboardUserStatus = (status: DashboardUserStatus | string): string => {
  switch (status) {
    case DashboardUserStatus.Enabled:
      return 'Ativo';
    case DashboardUserStatus.Blocked:
      return 'Bloqueado';
    case DashboardUserStatus.Error:
      return 'Erro';
    case DashboardUserStatus.Pending:
      return 'Pendente';
    default:
      return status;
  }
};
